import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.0306 15.9695L12.5306 8.46951C12.461 8.39977 12.3783 8.34445 12.2872 8.30671C12.1962 8.26897 12.0986 8.24954 12 8.24954C11.9014 8.24954 11.8038 8.26897 11.7128 8.30671C11.6218 8.34445 11.539 8.39977 11.4694 8.46951L3.96938 15.9695C3.82865 16.1102 3.74959 16.3011 3.74959 16.5001C3.74959 16.6992 3.82865 16.89 3.96938 17.0308C4.11011 17.1715 4.30098 17.2505 4.50001 17.2505C4.69903 17.2505 4.8899 17.1715 5.03063 17.0308L12 10.0604L18.9694 17.0308C19.0391 17.1004 19.1218 17.1557 19.2128 17.1934C19.3039 17.2311 19.4015 17.2505 19.5 17.2505C19.5986 17.2505 19.6961 17.2311 19.7872 17.1934C19.8782 17.1557 19.9609 17.1004 20.0306 17.0308C20.1003 16.9611 20.1556 16.8783 20.1933 16.7873C20.231 16.6963 20.2504 16.5987 20.2504 16.5001C20.2504 16.4016 20.231 16.304 20.1933 16.213C20.1556 16.1219 20.1003 16.0392 20.0306 15.9695Z",
		fill: "current"
	})
});
export default SvgArrowUp;
